export default "__VITE_ASSET__BESSqMaj__"